import { IHoatDongHangNgaySelectRequest } from "../models/request/danh-gia/IHoatDongHangNgaySelectRequest"
import { IHoatDongHangNgaySubmitRequest } from "../models/request/danh-gia/IHoatDongHangNgaySubmitRequest"
import { IDiemDanh } from "../models/response/danh-gia/IDiemDanh"
import { INhanXetHangNgay } from "../models/response/danh-gia/INhanXetHangNgay"
import { INhanXetHangNgayLop } from "../models/response/danh-gia/INhanXetHangNgayLop"
import { apiClient } from "./apiClient"

export const HOAT_DONG_HANG_NGAY_RESOURCE = "hoat-dong-hang-ngay"
export const HOAT_DONG_HANG_NGAY_BY_LOP_RESOURCE = "hoat-dong-hang-ngay/lop/{dm_lop_id}/ngay/{ngay}"
export const hoatDongHangHangApi = {
    SelectByLop: (payload: IHoatDongHangNgaySelectRequest) => {
        return apiClient.post(`${HOAT_DONG_HANG_NGAY_RESOURCE}/select-by-lop`, payload)
    },
    SubmitDiemDanh: (payload: IHoatDongHangNgaySubmitRequest<IDiemDanh[]>) => {
        return apiClient.put(`${HOAT_DONG_HANG_NGAY_RESOURCE}/diem-danh`, payload)
    },
    SubmitNhanXetLop: (payload: IHoatDongHangNgaySubmitRequest<INhanXetHangNgayLop>) => {
        return apiClient.put(`${HOAT_DONG_HANG_NGAY_RESOURCE}/nhan-xet-lop`, payload)
    },
    SubmitNhanXetHocSinh: (payload: IHoatDongHangNgaySubmitRequest<INhanXetHangNgay[]>) => {
        return apiClient.put(`${HOAT_DONG_HANG_NGAY_RESOURCE}/nhan-xet-hoc-sinh`, payload)
    }
}